import { defineComponent, ref, computed } from 'vue-demi';
import { s as script$1 } from './OrIcon-62793572.js';
import { resolveComponent, openBlock, createElementBlock, normalizeClass, createBlock, normalizeProps, mergeProps, createCommentVNode, createElementVNode, renderSlot } from 'vue';

const MenuItemRoot = [
// Layout
'layout-row',
// Spacing
'px-lg md:px-sm', 'py-sm+ md:py-sm', 'gap-sm md:gap-sm',
// Interactivity
'interactivity-auto',
// Typography
'typography-body-2-regular md:typography-caption-regular',
// Typography (selected)
'selected:typography-body-2-semibold selected:md:typography-caption-semibold',
// Theme
'theme-preset-3-primary', 'dark:theme-preset-3-primary-dark', 'theme-foreground-outline', 'dark:theme-foreground-outline-dark',
// Theme (hover)
'hover:md:theme-foreground-default', 'dark:hover:md:theme-foreground-default-dark',
// Theme (active)
'active:theme-foreground-default', 'dark:active:theme-foreground-default-dark',
// Theme (selected)
'selected:theme-foreground-default dark:selected:theme-foreground-default-dark'];

var script = defineComponent({
  name: 'OrMenuItem',
  components: {
    OrIcon: script$1
  },
  props: {
    icon: {
      type: [String, Object],
      default: undefined
    },
    selected: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click', 'focus', 'blur'],
  expose: ['root'],
  setup() {
    // Refs
    const root = ref();
    // Styles
    const rootStyles = computed(() => ['or-menu-item-v3', ...MenuItemRoot]);
    return {
      root,
      rootStyles
    };
  }
});

const _hoisted_1 = ["tabindex", "selected", "disabled"];
const _hoisted_2 = {
  class: /*#__PURE__*/normalizeClass(['truncate', 'w-full'])
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrIcon = resolveComponent("OrIcon");
  return openBlock(), createElementBlock("div", {
    ref: "root",
    class: normalizeClass(_ctx.rootStyles),
    tabindex: !_ctx.disabled ? 0 : null,
    selected: _ctx.selected ? '' : null,
    disabled: _ctx.disabled ? '' : null,
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('click', $event)),
    onFocus: _cache[1] || (_cache[1] = $event => _ctx.$emit('focus', $event)),
    onBlur: _cache[2] || (_cache[2] = $event => _ctx.$emit('blur', $event))
  }, [_ctx.icon ? (openBlock(), createBlock(_component_OrIcon, normalizeProps(mergeProps({
    key: 0
  }, typeof _ctx.icon === 'string' ? {
    icon: _ctx.icon
  } : _ctx.icon)), null, 16 /* FULL_PROPS */)) : createCommentVNode("v-if", true), createElementVNode("div", _hoisted_2, [renderSlot(_ctx.$slots, "default")])], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_1);
}

script.render = render;
script.__file = "src/components/or-menu-item-v3/OrMenuItem.vue";

export { script as s };
